import { FormHelperText, TextField, FormGroup } from "@mui/material";
import {
  AWSCrossAccountCredentialsRequest,
  awsCrossAccountCredentialsSchema,
} from "../../../../api/externalStorage";
import StorageForm from "./StorageForm";
import { useUpdateStorageCredentials } from "../../../../hooks/useExternalStorage";
import { useTranslation } from "react-i18next";

interface AWSCrossAccountProps {
  siteId: string;
  setIsOpen: (isOpen: boolean) => void;
}

export default function AWSCrossAccountCredentialsForm({
  siteId,
  setIsOpen,
}: AWSCrossAccountProps) {
  const { t } = useTranslation("configureStorage");
  const AWS_CRED_DEFAULT_VALUES = {
    SiteId: siteId,
  };
  const mutationHook = useUpdateStorageCredentials;

  return (
    <StorageForm
      siteId={siteId}
      id="edit-cross-account-credentials"
      schema={awsCrossAccountCredentialsSchema}
      setIsOpen={setIsOpen}
      options={{
        defaultValues: AWS_CRED_DEFAULT_VALUES,
      }}
      requestProcessor={(data: AWSCrossAccountCredentialsRequest) => data}
      mutationHook={mutationHook}
    >
      {(form) => {
        const { register, formState } = form;
        return (
          <>
            <FormGroup>
              <TextField
                label={t("configureStorage:roleArn")}
                required
                fullWidth
                {...register("AWSCrossAccountCredentials.RoleArn")}
                error={!!formState.errors.AWSCrossAccountCredentials?.RoleArn}
              />
              <FormHelperText
                error={
                  !!formState.errors.AWSCrossAccountCredentials?.RoleArn
                    ?.message
                }
              >
                {formState.errors.AWSCrossAccountCredentials?.RoleArn?.message}
              </FormHelperText>
            </FormGroup>
          </>
        );
      }}
    </StorageForm>
  );
}
